module.exports = __webpack_public_path__ + "img/advantage_one.6a27178b.png";